module.exports = __webpack_public_path__ + "img/labmem_text_btnfinish_tc.73756b67.png";